import React, { useState } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";

//
import { setTelegramModal } from "../../redux/features/plan/slice";

//
import { menu } from "./menu";

//
import logo from "../../assets/img/logo.png";
import ScrollBar from "react-perfect-scrollbar";

//
import LogoutModal from "./LogoutModal";

function Sidebar({ sidebarActive, setSidebar, setTelegramModal }) {
  const [show, setShow] = useState(false);

  const token = localStorage.getItem("token");

  return (
    <>
      {sidebarActive && <div id="click-box" onClick={setSidebar}></div>}
      <div
        id="sidebar"
        className={`${sidebarActive ? "active" : ""} ${
          !token ? "full-side" : ""
        }`}
      >
        <div className="logo-box">
          <img src={logo} alt="logo" className="logo" />
        </div>

        <div className="links">
          <ScrollBar>
            {menu.map((menu, index) => (
              <>
                {(!menu.needLogin || (menu.needLogin && token)) && (
                  <div className="menu-box" key={index}>
                    {menu.title && (
                      <p className="categury-name">
                        {menu.title.toUpperCase()}
                      </p>
                    )}

                    {menu.submenu ? (
                      <>
                        {menu.submenu.map((sub, index) => (
                          <>
                            {(!sub.needLogin || (sub.needLogin && token)) && (
                              <>
                                {sub.innerLink && (
                                  <NavLink
                                    key={index}
                                    to={sub.link}
                                    end
                                    activeclassname="active"
                                    onClick={sidebarActive && setSidebar}
                                  >
                                    <span>
                                      {sub.icon ? (
                                        <i className={sub.icon}></i>
                                      ) : (
                                        <img
                                          src={
                                            process.env.PUBLIC_URL +
                                            `/icons/${sub.svg}.svg`
                                          }
                                          alt={sub.name}
                                        />
                                      )}
                                    </span>
                                    {sub.name}
                                  </NavLink>
                                )}

                                {sub.outerLink && (
                                  <a
                                    href={sub.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <span>
                                      {sub.icon ? (
                                        <i className={sub.icon}></i>
                                      ) : (
                                        <img
                                          src={
                                            process.env.PUBLIC_URL +
                                            `/icons/${sub.svg}.svg`
                                          }
                                          alt={sub.name}
                                        />
                                      )}
                                    </span>
                                    {sub.name}
                                  </a>
                                )}

                                {sub.modal && (
                                  <a
                                    onClick={() => setTelegramModal(true)}
                                    className="pointer"
                                  >
                                    <span>
                                      {sub.icon ? (
                                        <i className={sub.icon}></i>
                                      ) : (
                                        <img
                                          src={
                                            process.env.PUBLIC_URL +
                                            `/icons/${sub.svg}.svg`
                                          }
                                          alt={sub.name}
                                        />
                                      )}
                                    </span>
                                    {sub.name}
                                  </a>
                                )}
                              </>
                            )}
                          </>
                        ))}
                      </>
                    ) : (
                      <>
                        {menu.innerLink && (
                          <NavLink
                            to={menu.link}
                            end
                            activeclassname="active"
                            onClick={sidebarActive && setSidebar}
                          >
                            <span>
                              {menu.icon ? (
                                <i className={menu.icon}></i>
                              ) : (
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    `/icons/${menu.svg}.svg`
                                  }
                                  alt={menu.name}
                                />
                              )}
                            </span>
                            {menu.name}
                          </NavLink>
                        )}

                        {menu.outerLink && (
                          <a
                            href={menu.link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <span>
                              {menu.icon ? (
                                <i className={menu.icon}></i>
                              ) : (
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    `/icons/${menu.svg}.svg`
                                  }
                                  alt={menu.name}
                                />
                              )}
                            </span>
                            {menu.name}
                          </a>
                        )}

                        {menu.modal && (
                          <a className="pointer">
                            <span>
                              {menu.icon ? (
                                <i className={menu.icon}></i>
                              ) : (
                                <img
                                  src={
                                    process.env.PUBLIC_URL +
                                    `/icons/${menu.svg}.svg`
                                  }
                                  alt={menu.name}
                                />
                              )}
                            </span>
                            {menu.name}
                          </a>
                        )}
                      </>
                    )}
                  </div>
                )}
              </>
            ))}
          </ScrollBar>
        </div>

        <div className="logout">
          <p onClick={() => setShow(true)}>
            Logout
            <i className="icon icon-logout"></i>
          </p>
        </div>

        <LogoutModal show={show} setShow={(status) => setShow(status)} />
      </div>
    </>
  );
}

Sidebar.propTypes = {
  sidebarActive: PropTypes.bool.isRequired,
  setSidebar: PropTypes.func.isRequired,
  setTelegramModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setTelegramModal,
};

export default connect(null, mapDispatchToProps)(Sidebar);
